<app-traitement-data titre="Durée" [sousTitre]="patient!.tableauDeBord?.duree?.date | aLaDateDu"
    [statut]="patient!.tableauDeBord?.duree?.value ? 'info' : 'warning'">
    {{ patient!.tableauDeBord?.duree?.value ?? 'Pas de donnée' }}
</app-traitement-data>